<template>
  <div class="exercise-record">
    <div class="record-header">
      <div class="title-wrapper">
        <div class="title-bar" />
        <h3 class="title">运动记录</h3>
        <span class="total-time">总时长：{{ totalTime }}分钟</span>
      </div>
      <div class="time-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['tab-btn', { active: activeTab === tab.value }]"
          @click="handleTabChange(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>
    </div>

    <div class="record-content">
      <!-- 左侧统计 -->
      <div class="left-stats">
        <div class="exercise-icon">
          <div class="icon-circle">
            <img src="@/assets/icon/yundong.png" style="width: 60px;" alt="">
          </div>
        </div>
        <div class="legend">
          <div class="legend-item">
            <span class="legend-dot blue" />
            <span class="legend-label">达标天数</span>
          </div>
          <div class="legend-item">
            <span class="legend-dot orange" />
            <span class="legend-label">未达标天数</span>
          </div>
        </div>
        <div class="stat-row">
          <div class="stat-item">
            <span class="stat-value">{{ stats.standard || 0 }}</span>
            <span class="stat-unit">天</span>
          </div>
          <div class="stat-item">
            <span class="stat-value">{{ stats.notStandard || 0 }}</span>
            <span class="stat-unit">天</span>
          </div>
        </div>
      </div>

      <!-- 右侧运动列表 -->
      <div class="exercise-list">
        <div
          v-for="(exercise, index) in displayList"
          :key="index"
          class="exercise-item"
        >
          <div class="exercise-image">
            <img v-if="exercise.image" :src="exercise.image" :alt="exercise.name">
            <img v-else src="@/assets/icon/zanwu.png" alt="">
            <div v-if="exercise.isStandard !== undefined" class="status-badge" :class="exercise.isStandard ? 'standard' : 'not-standard'">
              {{ exercise.isStandard ? '达标' : '未达标' }}
            </div>
          </div>
          <div class="exercise-time">
            <span class="time">{{ exercise.time }}</span>
            <span class="time-unit">分钟</span>
          </div>
          <div class="exercise-name">{{ exercise.name }}</div>
        </div>
        <div v-if="displayList.length === 0" class="empty-text">
          暂无记录
        </div>
      </div>
    </div>

    <!-- 进度条 -->
    <div class="progress-bar">
      <div class="progress-fill" :style="{ width: progressPercent + '%' }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExerciseRecord',
  props: {
    exerciseList: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: '3' // 改为 '3'
    },
    stats: {
      type: Object,
      default: () => ({ totalCount: 0, standard: 0, notStandard: 0 })
    }
  },
  data() {
    return {
      tabs: [
        { label: '日', value: '1' }, // 改为 '1'
        { label: '周', value: '2' }, // 改为 '2'
        { label: '月', value: '3' } // 改为 '3'
      ]
    }
  },
  computed: {
    displayList() {
      return this.exerciseList.length > 0 ? this.exerciseList : [
      ]
    },
    totalTime() {
      return this.displayList.reduce((sum, item) => sum + (parseInt(item.time) || 0), 0)
    },
    progressPercent() {
      const total = (this.stats.standard || 0) + (this.stats.notStandard || 0)
      if (total === 0) return 0
      return Math.round((this.stats.standard / total) * 100)
    }
  },
  methods: {
    handleTabChange(value) {
      // 直接 emit 数字
      this.$emit('tab-change', value)
    }
  }
}
</script>

<style scoped>
.exercise-record {
  background: #fff;
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-bar {
  width: 4px;
  height: 18px;
  background: #333;
  border-radius: 2px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.total-time {
  font-size: 13px;
  color: #4a7dff;
  margin-left: 12px;
}

.time-tabs {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 4px 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-btn:hover {
  border-color: #4a7dff;
  color: #4a7dff;
}

.tab-btn.active {
  background: #4a7dff;
  border-color: #4a7dff;
  color: #fff;
}

.record-content {
  display: flex;
  gap: 30px;
}

.left-stats {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 120px;
  padding-top: 10px;
}

.exercise-icon {
  margin-bottom: 12px;
}

.icon-circle {
  width: 60px;
  height: 60px;
  background: #f0f5ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #4a7dff;
}

.icon-circle svg {
  width: 32px;
  height: 32px;
}

.legend {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.legend-dot.blue {
  background: #4a7dff;
}

.legend-dot.orange {
  background: #ff9f43;
}

.legend-label {
  font-size: 12px;
  color: #666;
}

.stat-row {
  display: flex;
  gap: 24px;
}

.stat-item {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #333;
}

.stat-unit {
  font-size: 13px;
  color: #666;
}

.exercise-list {
  flex: 1;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.exercise-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.exercise-image {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.exercise-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-badge {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  white-space: nowrap;
}

.status-badge.standard {
  background: #52c41a;
}

.status-badge.not-standard {
  background: #faad14;
}

.exercise-time {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.time {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.time-unit {
  font-size: 12px;
  color: #666;
}

.exercise-name {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.empty-text {
  flex: 1;
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 40px 0;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  margin-top: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4a7dff, #6b9fff);
  border-radius: 3px;
  transition: width 0.3s ease;
}
</style>
